import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const PreviewSkeleton = ({ iframeHeight, showAlert }) => {
  return (
    <Styles.Container>
      {showAlert && <Skeleton variant="rounded" width="100%" height={48} />}
      <Skeleton variant="rounded" width="100%" height={iframeHeight} />
    </Styles.Container>
  )
}

export default PreviewSkeleton
